import * as React from "react";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { JournalEntryItemType, JournalEntryType } from "model/journal.model";
import { User } from "model/user.model";
import ContactTypeIcon from "components/Icon/ContactTypeIcon";
import { Col, Container, Row } from "@cc/react-components/Grid";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  journalEntries: Array<JournalEntryType>;
  journalEntryItems: Array<JournalEntryItemType>;
  user: User;
}

const TimelineItemDetails = ({
  journalEntries,
  journalEntryItems,
  user,
}: Props) => {
  const [t] = useTranslation();

  /** ---- RENDER FUNCTION ---- */
  return (
    <Container>
      {renderJournalEntries(journalEntries, journalEntryItems, t)}
      {renderAuthorFooter(user)}
    </Container>
  );
};

const renderAuthorFooter = (user: User) => {
  return (
    <Row>
      <Col className="text-right">
        <small>{user?.displayName ?? ""}</small>
      </Col>
    </Row>
  );
};

const renderJournalEntries = (
  journalEntries: Array<JournalEntryType>,
  journalEntryItems: Array<JournalEntryItemType>,
  t: TFunction
) => {
  return journalEntries.map((entry: JournalEntryType) => {
    return renderJournalEntryItems(
      journalEntryItems.filter((item) =>
        entry.journalEntryItems.includes(item.id)
      ),
      t
    );
  });
};
const renderJournalEntryItems = (
  journalEntryItems: Array<JournalEntryItemType>,
  t: TFunction
) => {
  return journalEntryItems.map((item: JournalEntryItemType) => {
    return (
      <Row key={item.id}>
        <Col xs={2}>
          <ContactTypeIcon type={item.type} />
        </Col>
        <Col xs={10}>
          <h5 className="my-1">
            {item.title}
            {item.statusKey && <br />}
            {item.statusKey && (
              <small className="text-muted">{t(item.statusKey)}</small>
            )}
          </h5>
        </Col>
      </Row>
    );
  });
};

export default TimelineItemDetails;
